// src/sites/Imprint.jsx
import React from "react";
import { useI18n } from "../I18nProvider";
import "./styles.css";

export default function Imprint() {
  const { t } = useI18n();

  return (
    <>

          <br></br><br></br><br></br>
      <section id="imprint" className="services">
        <div className="container">
          <h2>{t("imprint.title")}</h2>

            <img
              src="/images/logo-mah2.webp"
              alt="AUTO M.A.H. Logo"
              className="logo-image"
              style={{ height: "72px", width: "auto" , paddingBottom: "1rem"}}
            />

          <div
            className="privacy-content"
            dangerouslySetInnerHTML={{ __html: t("imprint.html") }}
          />
        </div>
      </section>
            <br></br><br></br><br></br>
    </>
  );
}
